import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50bc2f16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "simple-rich-editor" }
const _hoisted_2 = { style: {"max-width":"100%","border":"1px solid #ccc"} }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div id=\"rich-editor-overlay\" style=\"position:fixed;top:0;left:0;width:100%;height:100%;display:none;background-color:rgba(0, 0, 0, 0.5);z-index:9999;\" data-v-50bc2f16></div><div id=\"rich-editor-loading\" style=\"position:fixed;top:50%;left:50%;display:none;transform:translate(-50%, -50%);background-color:#fff;padding:20px;border-radius:5px;z-index:10000;align-items:center;justify-content:center;flex-direction:column;\" data-v-50bc2f16><img src=\"https://jstd-auxi.oss-cn-hangzhou.aliyuncs.com/auxi/2023-07-09/loading.gif\" style=\"width:40%;height:40%;\" alt=\"Loading-Box\" data-v-50bc2f16><span style=\"margin-top:20px;\" data-v-50bc2f16>努力上传中，请耐心等待...</span><span style=\"margin-top:10px;font-size:12px;color:gray;\" data-v-50bc2f16>Tip:视频尺寸推荐 宽度:690 高度:auto</span></div>", 2)

import "@wangeditor/editor/dist/css/style.css"
import {onBeforeUnmount, ref, shallowRef, watch} from "vue"
import {Editor, Toolbar} from "@wangeditor/editor-for-vue"
import {ElMessage} from "element-plus"
import type {IEditorConfig, IToolbarConfig} from "@wangeditor/core"
import {getListData} from "@/service/main/system";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'RichTextEditor',
  props: {
  modelValue: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef()

// 工具栏配置
const toolbarConfig: Partial<IToolbarConfig> = {
  excludeKeys: [
    "fullScreen",
    "blockquote",
    "group-more-style",
    "bulletedList",
    "numberedList",
    "lineHeight",
    "todo",
    "group-indent",
    "insertTable",
    "codeBlock",
    "divider"
  ],
}

// 编辑器配置
const editorConfig: Partial<IEditorConfig> = {
  maxLength: 10000,
  autoFocus: false,
  placeholder: '请输入内容...',
  readOnly: props.disabled,
  MENU_CONF: {
    "uploadImage": {
      async customUpload(file: any, insertFn: any) {
        await upLoadImgVideo(file, insertFn);
      }
    },
    "uploadVideo": {
      async customUpload(file: any, insertFn: any) {
        await upLoadImgVideo(file, insertFn);
      }
    }
  }
}

// 封装 - 上传图片、视频
const upLoadImgVideo = async (file: any, insertFn: any) => {
  if (file.size / 1024 / 1024 > 500) {
    ElMessage.error(`文件大小不能超过500MB!`)
    return false
  } else {
    showLoading()
    let data = await getListData('/oss/policy', {})
    let type = file.name.split(".")[1]
    let randomNumber = Math.floor(Math.random() * (9999999999999 - 1000000000000 + 1) + 1000000000000);
    let key = data.dir + randomNumber + "." + type
    let formData = new FormData()
    formData.append('accessId', data.accessId)
    formData.append('policy', data.policy)
    formData.append('signature', data.signature)
    formData.append('expire', data.expire)
    formData.append('dir', data.dir)
    formData.append('OSSAccessKeyId', data.accessId)
    formData.append('host', data.host)
    formData.append('key', key)
    formData.append("file", file)
    let fileUrl = data.host
    let config = {
      headers: {"Content-Type": "multipart/form-data"}
    }
    axios.post(fileUrl, formData, config).then(res => {
      if (res.status == 200 || res.status == 204) {
        if (key.includes('.mp4')) {
          insertFn(data.host + "/" + key, data.host + "/" + key + "?x-oss-process=video/snapshot,t_1000,m_fast")
        } else {
          insertFn(data.host + "/" + key)
        }
        hideLoading()
      } else {
        ElMessage.error("上传文件失败")
      }
    })
  }
}

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null) return
  editor.destroy()
})

const handleCreated = (editor: any) => {
  editorRef.value = editor
  // 如果有初始值，设置内容
  if (props.modelValue) {
    editor.setHtml(props.modelValue)
  }
}

// 获得输入的内容
const handleChange = (editor: any) => {
  const html = editor.getHtml()
  emit('update:modelValue', html)
}

// 监听外部值变化，同步到编辑器
watch(() => props.modelValue, (newVal) => {
  const editor = editorRef.value
  if (editor && newVal !== editor.getHtml()) {
    editor.setHtml(newVal || '')
  }
})

// 监听 disabled 变化，同步到编辑器
watch(() => props.disabled, (newVal) => {
  const editor = editorRef.value
  if (editor) {
    if (newVal) {
      editor.disable()
    } else {
      editor.enable()
    }
  }
})

// 显示遮罩和加载框
function showLoading() {
  const loading = document.getElementById('rich-editor-loading')
  const overlay = document.getElementById('rich-editor-overlay')
  if (loading) loading.style.display = 'flex'
  if (overlay) overlay.style.display = 'block'
}

// 隐藏加载框
function hideLoading() {
  const loading = document.getElementById('rich-editor-loading')
  const overlay = document.getElementById('rich-editor-overlay')
  if (loading) loading.style.display = 'none'
  if (overlay) overlay.style.display = 'none'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Toolbar), {
        style: {"border-bottom":"1px solid #ccc"},
        editor: editorRef.value,
        defaultConfig: toolbarConfig,
        mode: 'default'
      }, null, 8, ["editor"]),
      _createVNode(_unref(Editor), {
        style: {"height":"300px","overflow-y":"auto"},
        defaultConfig: editorConfig,
        mode: 'default',
        onOnCreated: handleCreated,
        onOnChange: handleChange
      })
    ]),
    _hoisted_3
  ]))
}
}

})